export default "__VITE_ASSET__BYr$OaLG__"